import { gql } from 'apollo-angular';

export const GET_NT_Audiences = gql`
query getNtAudiences($preview: Boolean! = false) {
  ntAudienceCollection(preview: $preview, limit: 50) {
    items {
      sys {
        id
      }
      ntAudienceId
      ntName
      ntDescription
      ntRules
    }
  }
}`;
